<div
  *ngIf="minified && hasAssignedSources"
  [ngClass]="'reviews ' + (classList | addClassList: { mainClass: 'reviews--' }) + ' reviews--minified'"
>
  <div *ngIf="!isElfsightLoaded" class="reviews__placeholder">
    <app-loading-placeholder [type]="placeholderTypes.elfsightMinified" />
  </div>
  <div
    #reviewsContentElement
    class="reviews__content"
    [ngClass]="{ 'reviews__content--hidden': !isElfsightLoaded }"
    (click)="reviewsClicked($event)"
  >
    <div
      id="reviews-widget-badge"
      data-elfsight-app-lazy
      [class]="elfsightBadgeWidgetId"
      [attr.data-elfsight-app-sources]="assignedSources"
    ></div>
  </div>
</div>

<ng-container *ngIf="!minified && hasAssignedSources">
  <div #reviewsContentElement class="reviews__content" (click)="reviewsClicked($event)">
    <div
      id="reviews-widget-carousel"
      [class]="elfsightCarouselWidgetId"
      [attr.data-elfsight-app-sources]="assignedSources"
    ></div>
  </div>
</ng-container>
